<div *ngIf="create" style="padding:20px;">
    <div *ngIf="opmPartners && opmPartners.length > 0">
        <nb-form-field>    
            <nb-select [(ngModel)]="partnerId" [placeholder]="'partner'| translation" (selectedChange)="getNewView()">
                <nb-option *ngFor="let partner of opmPartners" [value]="partner.id">{{partner.name}}</nb-option>
            </nb-select>
        </nb-form-field>
    </div>
    <app-view [info]="create_info" [items]="create?.data?.content" [data]="create_data"></app-view>    
    <div style="text-align:right;">
        <button nbButton status="primary" (click)="submitForm()" [disabled]="!viewLoaded || hasErrors()">{{'create'| translation}}</button>
    </div>
</div>
